import { Component, Input, Output, EventEmitter } from '@angular/core';

import { LanguageService, VoiceService } from '../../_services/index';

import { Voice, Game, GameTemplate } from '../../classes/index';

import { NbMenuService } from '@nebular/theme';

import { Storage, ref, uploadBytesResumable, percentage, UploadTask } from '@angular/fire/storage';

import { environment } from '../../../environments/environment';

import { map, filter, finalize } from 'rxjs/operators';

import md5Hex from 'md5-hex';

import { IdTools } from '../../utils/id-tools';

@Component({
    selector: 'voice-editor',
    templateUrl: 'voice-editor.component.html',
    styleUrls: ['./voice-editor.component.scss'],
    standalone: false
})

export class VoiceEditorComponent {

  @Input() view = 'columns';

  constructor(public languageService: LanguageService,
    private voiceService: VoiceService,
    private menuService: NbMenuService,
    private storage: Storage) {
      this.languages = languageService.languagesCodes;

      this.menuService.onItemClick()
      .pipe(
        filter(({ tag }) => tag === ('voice-editor'+this.attribute)),
        map(({ item: { title } }) => title),
      )
      .subscribe(title => {
        console.log('onItemClick:'+title);
        if(title == 'Apply selected language(s)'){
          this.applyChanges.emit('selected');
        }
        if(title == 'Apply all languages'){
          this.applyChanges.emit('all');
        }
      });
  }

  applyMenu = [
    { title: 'Apply selected language(s)' },
    { title: 'Apply all languages' }
  ]
  loading = [];

  task;
  progress;

  generatingVoice;
  saving;

  @Input() defaultLang;
  @Input() attribute;
  @Input() languages;

  @Input() model: any = {};
  @Input() templateModel;

  @Input() game:Game;
  @Input() template:GameTemplate;
  @Input() missionId;
  @Input() characters;
  
  modelVoices = {};
  @Input() set voices(voices){
    if(voices){
      this.modelVoices = {};
      for(let voice of voices){
        if(voice.elementId == this.model.id){
          this.modelVoices[voice.lang] = voice;
        }
      }
    }
  };

  templateModelVoices = {};
  @Input() set templateVoices(voices){
    if(voices){
      this.templateModelVoices = {};
      for(let voice of voices){
        if(voice.elementId == this.model.id){
          this.templateModelVoices[voice.lang] = voice;
        }
      }
    }
  };

  @Input() showApplyChanges = false;

  @Output() save: EventEmitter<any> = new EventEmitter<any>();
  @Output() edit: EventEmitter<any> = new EventEmitter<any>();
  @Output() applyChanges: EventEmitter<any> = new EventEmitter<any>();
  @Output() updateFromTemplate: EventEmitter<any> = new EventEmitter<any>();

  _changes
  @Input() set changes(changes){
    //console.log('set changes:'+JSON.stringify(changes));
    this._changes = changes;
    if(changes) this.checkForChanges();
  };
  changeCount = 0;
  
  didChange = [];
  checkForChanges(){
    this.didChange = [];
    this.changeCount = 0;
    for (let i = 0; i < this._changes.length; i++) {
      if(this.attribute === this._changes[i].fieldName && this._changes[i].languages){
        for (let j = 0; j < this._changes[i].languages.length; j++) {
          this.didChange[this._changes[i].languages[j]] = true;
          this.changeCount++;
        }
      }
    }
    //console.log('this.didChange:'+JSON.stringify(this.didChange));
  }

  isEmpty(clang){
    if(this.templateModel && (!this.model[clang] || this.model[clang] == '')){
      for(let lang of this.languages){
        if(this.templateModel[lang] && this.templateModel[lang].length>0){
          return true;
        }
      }
    }
    return false;
  }

  getTextData(lang){
    //model can be simple (lang map) or structured (object)
    if(this.model.data){
      if(this.model.type == 'dialog'){
        return this.model.data.text[lang];
      }
      else{
        return this.model.data[lang];
      }
    }
    return this.model[lang];
  }

  editModel() {
    this.edit.emit();
  }

  getTextHash(lang){
    return md5Hex(this.getTextData(lang));
  }

  getTtsVoiceId(lang){
    if(this.model.data?.characterId){
      for(let char of this.characters){
        if(char.id == this.model.data?.characterId){
          return char.getTtsVoiceId(this.model.data?.moodId, lang);
        }
      }
    }
    else if(this.game && this.game.getTtsVoiceId(lang)){
      return this.game.getTtsVoiceId(lang);
    }
    else if(this.template && this.template.getTtsVoiceId(lang)){
      return this.template.getTtsVoiceId(lang);
    }
    return null;
  }

  voicePreview = {};
  async generateVoice(lang){
    this.generatingVoice = true;
    this.voicePreview[lang] = await this.voiceService.getAudio(this.getTextData(lang), this.getTtsVoiceId(lang));
    this.generatingVoice = false;
  }

  playVoice(lang){
    this.voiceService.playAudio(this.voicePreview[lang]);
  }

  getPreviewSize(lang){
    if(this.voicePreview[lang]){
      return Math.round(this.voicePreview[lang].byteLength/1024)+'KB';
    }
    return 0;
  }

  /*getVoiceObject(elementId, lang){
    if(this.voices){
      for(let voice of this.voices){
        if(voice.elementId == elementId && voice.lang == lang){
          return voice;
        }
      }
    }
    return null;
  }*/

  async saveVoice(lang){
    this.saving = true;
    const filePath = this.getStoragePath();
    if(!this.model.id){
      this.model.id = IdTools.makeIdAllChars(10);
      console.log('generate model id:'+this.model.id);
      this.save.emit();
    }
    let voiceId;
    let currentVoice = this.modelVoices[lang];
    if(currentVoice){
      voiceId = currentVoice.id;
      console.log('existing voiceId:'+voiceId);
    }
    else{
      voiceId = this.voiceService.createVoiceRef(filePath).id;
      console.log('new voiceId:'+voiceId);
    }
    const txtHash = md5Hex(this.getTextData(lang));
    console.log('txt hash:'+txtHash);
    
    let fileName = `/${voiceId}.mp3`;

    let uploadRef = ref(this.storage, filePath+fileName);
    let task:any = uploadBytesResumable(uploadRef, this.voicePreview[lang]);

    task.then(async () => {
      const url = 'https://storage.googleapis.com/'+environment.firebase.storageBucket+'/'+filePath+fileName;
      console.log('file uploaded to:'+url);
      let res = await this.createOrUpdateVoice(voiceId, this.getTtsVoiceId(lang), txtHash, lang, url, filePath+fileName, Math.round(this.voicePreview[lang].byteLength));
      console.log('createMedia res:'+res);
      this.saving = false;
      setTimeout(() => {
        delete this.progress;
        delete this.voicePreview[lang];
      }, 1000);
    });

    // Percentage observer
    percentage(task).subscribe((percentage) => {
      this.progress =  Math.round(percentage.progress);
    });
  }

  async createOrUpdateVoice(voiceId, ttsVoiceId, textHash, lang, fileURL, filePath, fileSize){
    let voice = new Voice(this.getStoragePath());
    voice.id = voiceId;
    voice.elementId = this.model.id;
    voice.lang = lang;
    if(this.template){
      voice.templateId = this.template.id;
    }
    if(this.game){
      voice.gameId = this.game.id;
    }
    voice.textHash = textHash;
    voice.missionId = this.missionId;
    voice.ttsVoiceId = ttsVoiceId;
    voice.fileURL = fileURL;
    voice.filePath = filePath;
    voice.fileSize = fileSize;
    voice.lastUpdate = new Date().getTime();
    console.log('media to add:'+JSON.stringify(voice));
    await this.voiceService.setVoice(voice);
    console.log('added media:'+voice.id);
  }

  getStoragePath(){
    let storagePath;
    if(this.game){
      storagePath = `games/${this.game.id}/voices`;
    }
    else{
      storagePath = `game_templates/${this.template.id}/voices`;
    }
    return storagePath;
  }

  updateFieldFromTemplate(){
    this.updateFromTemplate.emit();
  }
}
